/**
 * IT Admin → User lookup (5 Oct): pick a person from the directory, open
 * their profile. The directory search is the same one every form uses.
 *
 * A card since 6 Oct (decision 35): it sits at the top of the IT Admin hub,
 * which is what `/it-admin` opens, so the lookup is still one step away.
 */

import { Field, Typography } from "@norican/react";
import { useNavigate } from "react-router";

import { SectionCard } from "@/components/common";
import { EmployeePicker } from "@/features/tickets";
import { useT } from "@/i18n";
import { logger } from "@/lib/logger";

export function UserLookupCard() {
  const { t } = useT("tickets");
  const navigate = useNavigate();
  return (
    <SectionCard title={t("itAdmin.lookup.title")}>
      <div className="flex flex-col gap-3">
        <Typography variant="body-sm" tone="muted">
          {t("itAdmin.lookup.intro")}
        </Typography>
        <Field name="it-admin-person" label={t("itAdmin.lookup.label")}>
          <EmployeePicker
            name="it-admin-person"
            value={null}
            defaultDisplayValue={null}
            onChange={(entry) => {
              if (entry !== null) {
                logger.debug("[it-admin] open profile", entry.id);
                void navigate(`/it-admin/people/${encodeURIComponent(entry.id)}`);
              }
            }}
            aria-label={t("itAdmin.lookup.label")}
          />
        </Field>
        <Typography variant="caption" tone="muted">
          {t("itAdmin.lookup.logged")}
        </Typography>
      </div>
    </SectionCard>
  );
}
